import { type PropsWithChildren, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { broadcast_logout, close, type LogoutMessage, open } from "@/modules/app/messaging/broadcast.ts";
import { logout } from "@/redux/modules/auth.ts";
import type { ReduxDispatch } from "@/redux/redux-utils.ts";

export const BroadcastLogoutProxy = ({ children }: PropsWithChildren) => {
  const dispatch = useDispatch<ReduxDispatch>();

  const handleMessage = useCallback(
    (event: MessageEvent<LogoutMessage>) => {
      if (event.data.logout === true) {
        dispatch(logout());
      }

      if (event.data.reload === true) {
        window.location.reload();
      }
    },
    [dispatch],
  );

  useEffect(() => {
    open();
    broadcast_logout?.addEventListener("message", handleMessage);

    return () => {
      broadcast_logout?.removeEventListener("message", handleMessage);
      close();
    };
  }, [handleMessage]);

  return children;
};
